import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { ValidationErrors } from '@angular/forms';

@Component({
  selector: 'app-input-errors',
  templateUrl: './input-errors.component.html',
  styleUrls: ['./input-errors.component.scss'],
  changeDetection: ChangeDetectionStrategy.Default,
})
export class InputErrorsComponent {
  @Input() errors!: ValidationErrors;

  get errorMessage(): string {
    const key = Object.keys(this.errors)[0];
    const messages: { [key: string]: string } = {
      required: 'Required',
      email: 'Email not valid',
      minlength: `Min ${this.errors[key]?.requiredLength} characters`,
      maxlength: `Max ${this.errors[key]?.requiredLength} characters`,
      min: `Min value - ${this.errors[key]?.min}`,
      max: `Max value - ${this.errors[key]?.max}`,
      uppercase: 'One uppercase required',
      lowercase: 'One lowercase required',
      number: 'One number required',
      special: 'One special character required',
      matchPassword: 'Passwords do not match',
      numbers: 'Must be number',
      phoneNumber: 'Phone number not valid',
      date: 'Not valid date',
      latitude: 'Latitude not valid',
      longitude: 'Longitude not valid',
      validURL: 'Not valid url',
    };
    return messages[key];
  }
}
